import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, ArrowUpRight } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Logo } from "./Logo";

export const NAV = [
  { to: "/", label: "Home", id: "home" },
  { to: "/services", label: "Services", id: "services" },
  { to: "/portfolio", label: "Portfolio", id: "portfolio" },
  { to: "/about", label: "About", id: "about" },
  { to: "/contact", label: "Contact", id: "contact" },
];

const linkCls = ({ isActive }) =>
  `relative text-sm font-medium transition-colors duration-200 ${isActive ? "text-cyan-300" : "text-slate-400 hover:text-white"}`;

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="site-navbar" className="sticky top-0 z-50 border-b border-white/5 bg-[#07090E]/75 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-12">
        <Logo />
        <nav className="hidden items-center gap-8 md:flex">
          {NAV.map((n) => (
            <NavLink key={n.id} to={n.to} end className={linkCls} data-testid={`nav-link-${n.id}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden md:block">
          <Link to="/login" data-testid="nav-link-login"
            className="inline-flex items-center gap-1.5 rounded-full border border-white/10 px-4 py-2 text-sm text-slate-300 transition-colors duration-200 hover:border-cyan-400/50 hover:text-white">
            Sign in <ArrowUpRight className="h-3.5 w-3.5" />
          </Link>
        </div>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button data-testid="mobile-menu-toggle" aria-label="Open menu"
              className="grid h-10 w-10 place-items-center rounded-lg border border-white/10 text-slate-200 md:hidden">
              <Menu className="h-5 w-5" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" data-testid="mobile-menu-drawer" className="w-[82%] max-w-xs border-white/10 bg-[#0B0F18]">
            <SheetTitle className="sr-only">Menu</SheetTitle>
            <div className="mt-10 flex flex-col gap-1">
              {NAV.map((n) => (
                <NavLink key={n.id} to={n.to} end onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${n.id}`}
                  className={({ isActive }) => `rounded-lg px-3 py-3 font-display text-lg transition-colors ${isActive ? "bg-cyan-400/10 text-cyan-300" : "text-slate-300 hover:bg-white/5"}`}>
                  {n.label}
                </NavLink>
              ))}
              <Link to="/login" onClick={() => setOpen(false)} data-testid="mobile-nav-link-login"
                className="mt-4 rounded-lg border border-white/10 px-3 py-3 text-slate-300">
                Sign in
              </Link>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
}
